import React, { useState, useEffect, useContext } from 'react';
import { useQuery } from "@tanstack/react-query";
import { AuthContext } from '../context/authContext';
import { NuevaONGContext, useONGs } from '../context/NuevaONGContext';
import { useFormContext } from '../context/FormContext';

import Select from 'react-select';
import { Select_simple, Label, Input } from './ui';
import { optionsTipoSubsidio, optionsUniversidades } from '../datos/options';
import { esTipoSubsidio, normalizarTipoSubsidio } from '../utils/contactos';

//const SubsidioForm = ({ tipoSubsidio, onTipoSubsidioChange, organismoSolicitante, onOrganismoSolicitanteChange, organismoOtro, onOrganismoOtroChange }) => {
const SubsidioForm = () => { //sin recibir props

    const { nuevaONG } = useContext(NuevaONGContext);
    const { formA, updateField } = useFormContext();
    const { token } = useContext(AuthContext);
    const { datosGenerales } = formA;

    // 2. Movemos los manejadores al componente
    const handleTipoSubsidioChange = (newSubsidio) => {
        updateField('formA', 'datosGenerales', 'tipo_subsidio', newSubsidio);
    }

    // El id de la ONG va aparte del nombre. El nombre es texto libre y hay
    // nombres repetidos entre ONGs, asi que sin el id los contactos se piden
    // contra una ONG que puede no ser la correcta.
    const handleOrganismoSolicitanteChange = (value) => {
        updateField('formA', 'datosGenerales', 'organismo_solicitante', value || '');
    }

    const handleONGSeleccionada = (option) => {
        updateField('formA', 'datosGenerales', 'organismo_solicitante', option?.value || '');
        updateField('formA', 'datosGenerales', 'ongs_id', option?.id ?? null);
        // Cambiar de ONG deja sin sentido los contactos que estaban cargados:
        // son de otra ONG. Se limpian para no guardar contactos ajenos.
        updateField('formA', 'datosGenerales', 'contacto_proyecto', '[]');
    }

    const handleOrganismoOtroChange = (value) => {
        updateField('formA', 'datosGenerales', 'organismo_otro', value || '');
    }
    useEffect(() => {
        if (nuevaONG) {
            cargarOpcionesONG();
        }
    }, [nuevaONG]); // El efecto se ejecutará cuando nuevaONG cambie  

    //24-abr-2025: estado para las options recibidas desde la api
    const [opcionesONG, setOpcionesONG] = useState([]);

    //para resetear organismo solicitante cuando el tipo de subsidio es Subsidio a municipio o Otro - 12-MAY-25
    //Las comparaciones son con esTipoSubsidio y no con === porque en la base
    //conviven "Subsidio a municipio" (437 obras) y "Subsidio a Municipio" (34).
    //Con === esas 34 no reseteaban nada y se quedaban con el organismo de la
    //ONG anterior.
    useEffect(() => {
        if (esTipoSubsidio(datosGenerales?.tipo_subsidio, 'Subsidio a municipio')) {
            //console.log("ENTROO SUBSIDIO A MUNICIPIO ???")

            if (datosGenerales?.organismo_otro !== "") {
                handleOrganismoOtroChange("") //onOrganismoOtroChange
            } else if (datosGenerales?.organismo_solicitante !== "") {
                handleOrganismoSolicitanteChange("")
            }
            handleONGSeleccionada(null);

        } else if (esTipoSubsidio(datosGenerales?.tipo_subsidio, 'Otro')) {
            handleOrganismoSolicitanteChange("")
            handleONGSeleccionada(null);
        } else if (esTipoSubsidio(datosGenerales?.tipo_subsidio, 'Subsidio a ONG')) {
            handleOrganismoOtroChange("")
        }
    }, [datosGenerales?.tipo_subsidio])


    const cargarOpcionesONG = async () => {
        try {
            const respuesta = await fetch('/api/ongs', {
                headers: { 'Authorization': `Bearer ${token}` }
            });//todasONGS
            if (!respuesta.ok) {
                throw new Error(`HTTP error! status: ${respuesta.status}`);
            }
            const data = await respuesta.json();
            // El id viaja en la opcion para poder pedir los contactos de ESA
            // ONG. El value sigue siendo el nombre porque es lo que se guarda
            // en cg_08_organismo_solicitante.
            const opcionesFormateadas = data.map(item => ({
                id: item.id,
                value: item.nombre,
                label: `${item.nombre} - Res: ${item.resolucion} - Cod: ${item.codigo}`
            }));
            //setOpcionesReferente(opcionesFormateadas);
            // Agregar la opción por defecto al inicio del array
            setOpcionesONG([{ id: null, value: null, label: 'Seleccionar...' }, ...opcionesFormateadas]);
        } catch (error) {
            console.error("Error al cargar los referentes:", error);
            // Aquí podrías mostrar un mensaje de error al usuario
        }
    };

    useEffect(() => {
        if (esTipoSubsidio(datosGenerales?.tipo_subsidio, 'Subsidio a ONG')) {
            cargarOpcionesONG();
        }
    }, [datosGenerales?.tipo_subsidio]); // El array vacío asegura que el efecto se ejecute solo una vez al montar el componente


    return (
        <div className="space-y-4">
            <div>
                <Label htmlFor="tipoSubsidio" className="block text-sm font-medium text-gray-700">
                    Tipo de subsidio
                </Label>
                <Select_simple
                    id="tipo_subsidio"
                    name="tipo_subsidio"
                    options={optionsTipoSubsidio}
                    // Se normaliza al mostrar: hay 34 obras con "Subsidio a
                    // Municipio" y los options usan la minuscula, asi que sin
                    // esto el select aparecia vacio en esas obras.
                    value={normalizarTipoSubsidio(datosGenerales?.tipo_subsidio)}
                    onChange={(e) => handleTipoSubsidioChange(e.target.value)}//onTipoSubsidioChange
                    placeholder="Seleccionar..."
                />
            </div>

            {esTipoSubsidio(datosGenerales?.tipo_subsidio, 'Subsidio a ONG') && (
                <div>
                    <Label htmlFor="nombreONG" className="block text-sm font-medium text-gray-700">
                        Nombre ONG
                    </Label>
                    <Select
                        id="nombreONG"
                        options={opcionesONG}
                        value={opcionesONG.find(ong => ong.value === datosGenerales?.organismo_solicitante) || null}
                        onChange={handleONGSeleccionada}
                        classNamePrefix="select"
                        placeholder="Buscar ONG..."
                        isSearchable
                        classNames={{
                            control: () => "border border-gray-300 rounded-md dark:bg-gray-700 dark:border-gray-600 dark:text-white h-9",
                        }}
                    />
                </div>
            )}

            {esTipoSubsidio(datosGenerales?.tipo_subsidio, 'Subsidio a Universidades') && (
                <div>
                    <Label htmlFor="nombreUniversidad" className="block text-sm font-medium text-gray-700">
                        Nombre Universidad
                    </Label>
                    <Select
                        id="nombreUniversidad"
                        options={optionsUniversidades}
                        value={datosGenerales?.organismo_solicitante ? optionsUniversidades.find(universidad => universidad.value === datosGenerales?.organismo_solicitante || universidad.siglas === datosGenerales?.organismo_solicitante) : null}
                        onChange={(e) => handleOrganismoSolicitanteChange(e.value)}//onOrganismoSolicitanteChange
                        classNamePrefix="select"
                        placeholder="Buscar Universidad..."
                        isSearchable
                        filterOption={(candidate, input) => {
                            if (!input) return true;
                            const searchInput = input.toLowerCase();
                            const value = candidate.value?.toLowerCase() || '';
                            const siglas = candidate.data?.siglas?.toLowerCase() || '';
                            return value.includes(searchInput) || siglas.includes(searchInput);
                        }}
                        formatOptionLabel={(option) => `${option.label} - ${option.siglas}`}
                        classNames={{
                            control: () => "border border-gray-300 rounded-md dark:bg-gray-700 dark:border-gray-600 dark:text-white h-9",
                        }}
                    />
                </div>
            )}

            {datosGenerales?.organismo_solicitante && (
                <div>
                    <p className="text-sm text-gray-500">
                        Organismo Solicitante: {datosGenerales?.organismo_solicitante}
                    </p>
                </div>
            )}

            {esTipoSubsidio(datosGenerales?.tipo_subsidio, 'Otro') && (
                <div>
                    <Label htmlFor="organismoOtro" className="block text-sm font-medium text-gray-700">
                        Organismo otro
                    </Label>
                    <Input
                        id="organismoOtro"
                        name="organismoOtro"
                        type="text"
                        placeholder="Organismo otro"
                        value={datosGenerales?.organismo_otro || ''}
                        onChange={e => handleOrganismoOtroChange(e.target.value)}//onOrganismoOtroChange
                    />
                </div>
            )}
        </div>
    );
};

export default SubsidioForm;